import PropTypes from 'prop-types'
import { isEmpty, startCase, omit } from 'lodash'
import { useHistory } from 'react-router'

import Modal from 'components/Modal'
import Loader from 'components/Loader'

import { removeStringFromWord } from 'utils/stringTransformations'

const PaymentDetailsComponent = ({ paymentTransactions, isLoading }) => {
  const history = useHistory()

  const title = (
    <span>
      <span className="responsive-header-mobile">Detailed Payment Info</span>
      <span className="responsive-header-desktop">
        Detailed Payment Information
      </span>
    </span>
  )

  // remove userAtrributes and token from creditCardDetails
  const filteredcreditCardDetails = omit(
    paymentTransactions[0]?.creditCardDetails,
    'token',
    'userAttributes'
  )

  // get credit card detils and return it entries
  const creditCardDetailsEntries = Object.entries(filteredcreditCardDetails)

  const onCloseModal = () => {
    history.push('/orders')
  }
  const onClickReturn = () => {
    history.goBack()
  }

  const signatureSrc = () => {
    if (
      !isEmpty(paymentTransactions) &&
      !isEmpty(paymentTransactions[0]?.receiptSignature)
    ) {
      return paymentTransactions[0]?.receiptSignature[0]
    } else {
      return null
    }
  }

  return (
    <Modal
      title={title}
      isReturnIcon
      id="paymentDetailsSlide"
      className="-overflow-y-auto"
      onClickReturn={onClickReturn}
      onClose={onCloseModal}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="modal-body">
            <div className="detailes">
              <div className="detailes__section">
                {creditCardDetailsEntries?.map((paymentTransaction, index) => {
                  if (!isEmpty(paymentTransaction)) {
                    const detailPaymentKey = removeStringFromWord(
                      paymentTransaction[0],
                      'freedompay'
                    )

                    return (
                      <div className="detailes__row" key={index}>
                        <p className="detailes__info">
                          {startCase(detailPaymentKey)}
                        </p>
                        <p className="detailes__info -ellipsis">
                          {paymentTransaction[1].toString()}
                        </p>
                      </div>
                    )
                  }
                  return null
                })}
              </div>
              {!isEmpty(signatureSrc()) && (
                <>
                  <div className="detailes__border-break"></div>
                  <div className="detailes__section">
                    <div className="detailes__row">
                      <p className="detailes__info">Signature</p>
                      <p className="detailes__info">
                        <img
                          className="detailes__image"
                          src={signatureSrc()}
                          alt={'Signature'}
                        />
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </Modal>
  )
}

PaymentDetailsComponent.propTypes = {
  paymentTransactions: PropTypes.array,
  isLoading: PropTypes.bool,
}

export default PaymentDetailsComponent
